module.exports = __webpack_public_path__ + "static/img/4.669c2f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/downloadImg/4.png
// module id = qJx0
// module chunks = 1